import { render } from "./IDate.vue?vue&type=template&id=1b72ee3d"
import script from "./IDate.vue?vue&type=script&lang=js"
export * from "./IDate.vue?vue&type=script&lang=js"

import "./IDate.vue?vue&type=style&index=0&id=1b72ee3d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__